import React from "react";
import { useNavigate } from "react-router";
import { useGlobalStore } from "~/store";
import "~/assets/sass/pages/dashboard/dashboard-business.scss";
import { useTranslation } from "react-i18next";

const Business = () => {
	const { t } = useTranslation();
	const [
		{
			user: { info },
		},
	] = useGlobalStore();
	const navigate = useNavigate();

	return (
		info.userRequirements === false && (
			<article className="item business">
				<p className="main-desc">{t("common.components.Business.mainDesc")}</p>
				<p className="sub-desc">{t("common.components.Business.subDesc")}</p>
				<button
					type="button"
					className="btn__solid btn-certify"
					onClick={() => navigate("/vc/info")}
				>
					{t("common.components.Business.btnCertify")}
				</button>
			</article>
		)
	);
};

export default Business;
